import axios from 'axios'
import router from './router'

axios.interceptors.response.use(null, function (error) {
  if (error.response.status === 401 && error.response.config.url !== '/api/auth/user') {
    if (router.currentRoute.path !== '/logout') {
      console.warn('Authorization failed. User session probably timed out.')
      router.push('/logout')
    }
    return false
  }
  return Promise.reject(error)
})

axios.interceptors.request.use(function (config) {
  const exp = +localStorage.getItem('tokenExp')
  if (['/login', '/logout'].indexOf(router.currentRoute.path) !== -1 || !exp) return config
  if (+new Date() >= exp) {
    if (router.currentRoute.path !== '/logout') {
      console.warn('Authentication token expired.')
      router.push('/logout')
    }
    return false
  }
  return config
}, function (err) {
  return Promise.reject(err)
})

export default axios
